import { Injectable } from '@angular/core';
import { Tab } from './tab.model';
import { BehaviorSubject } from 'rxjs';
@Injectable()
export class TabService {
    selectedIndex: number;
    tabs: Tab[] = this.getTabs();
    public tabSub = new BehaviorSubject<Tab[]>(this.tabs);
    getTabs(){
        const tabs: Tab[] = [];
        const tabDashBoard: Tab[] = [
            new Tab('Trang chủ', 'board'),
        ];
        let tabsObj: any;
        if (!localStorage.getItem('tabs')){
            localStorage.setItem('tabs', JSON.stringify(tabDashBoard));
            this.selectedIndex = 0;
            localStorage.setItem('selectedIndex', JSON.stringify(this.selectedIndex));
            return tabDashBoard;
        }else{
            tabsObj = JSON.parse(localStorage.getItem('tabs'));
            // tslint:disable-next-line: forin
            for (const i in tabsObj){
                tabs.push(tabsObj[i]);
            }
            // tslint:disable-next-line: radix
            this.selectedIndex = parseInt(localStorage.getItem('selectedIndex'));
            return tabs;
        }
    }
    newTab(item: Tab): void {
        let isHasItem = false;
        let indexTab = 0;
        let i = 0;
        this.tabs.forEach(element => {
            i ++;
            if (element.router === item.router){
            isHasItem = true;
            indexTab = i;
            }
        });
        if (isHasItem === false){
            this.tabs.push(item);
            this.selectedIndex = this.tabs.length - 1;
            localStorage.setItem('tabs', JSON.stringify(this.tabs));
        }else{
            this.selectedIndex = indexTab - 1;
        }
    }
    closeTab({ index }: { index: number }): void {
        this.tabs.splice(index, 1);
        localStorage.setItem('tabs', JSON.stringify(this.tabs));
    }
    closeAllTab(): void {
      this.tabs.splice(1, this.tabs.length - 1 );
      localStorage.setItem('tabs', JSON.stringify(this.tabs));
  }
}
